export default __webpack_public_path__ + "static/media/wallet-icon.2420875a.png";